import React, { useState } from "react";
import Find from './parts/Find'
import Mobile from './parts/Mobile'
import Download from './parts/Download'
import ChatBot from "../ChatBot";

function Footer() {

  const [openChat, setOpenChat] = useState(false);

  return (
    <>
      <Find /> 
      <Mobile />
      <Download />
      <ChatBot
        isChatOpen={openChat}
        handleChatChange={() => setOpenChat(!openChat)}
      />
    </>
  )
}

export default Footer